// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root : {
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <MuiCore.Slide direction="left" ref={ref} {...props} />;
});


/*
 * Generic confirmation dialog
 */

class Confirm extends Component {
  render() {
    const { open, onConfirm, onCancel, confirmLabel,
            cancelLabel, title, text} = this.props;
    
    return (
      <React.Fragment>
        <MuiCore.Dialog open={open}
                        onClose={onCancel}
                        maxWidth="xs"
                        TransitionComponent={Transition}>
          <MuiCore.DialogTitle style={{fontFamily: 'Sofia-bold', color: '#000'}}>{title}</MuiCore.DialogTitle>
          <MuiCore.DialogContent style={{fontFamily: 'Sofia', color: '#000'}}>{text}</MuiCore.DialogContent>
          <MuiCore.DialogActions>
            <MuiCore.Button onClick={onConfirm}>
              {confirmLabel}
            </MuiCore.Button>
            <MuiCore.Button variant='text' onClick={onCancel} style={{fontFamily: 'Sofia', color: '#000'}}>
              {cancelLabel}
            </MuiCore.Button>
          </MuiCore.DialogActions>
        </MuiCore.Dialog>
      </React.Fragment>
    );
  }
}

Confirm.propTypes = {
  open : PropTypes.bool.isRequired,
  onConfirm : PropTypes.func.isRequired,
  onCancel : PropTypes.func.isRequired,
  confirmLabel : PropTypes.string,
  cancelLabel : PropTypes.string,
  title : PropTypes.string,
  text : PropTypes.string,
}

Confirm.defaultProps = {
  open : false,
  confirmlabel : 'Yes',
  cancelLabel : 'Cancel',
  title : 'Confirm',
  text : 'Are you sure?',
}


export default withStyles(styles)(Confirm);

